import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Form,
    Input,
    InputGroup,
    InputGroupText,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';
import {
    FaEye,
    FaSearch,
    FaDownload,
    FaCalendarAlt,
    FaPaw,
    FaPills,
    FaChartBar,
    FaUser,
    FaClipboardList,
    FaStethoscope,
    FaUsers
} from 'react-icons/fa';

const LivestockActivity = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState('');

    const get_livestock_Activity = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Activity/liv_activity_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl: index + 1,
                    farmer_id: row.farmer_id,
                    f_name: row.f_name,
                    activity_date: row.activity_date?.split(" ")[0].split('-').reverse().join('-'),
                    activity_desc: row.activity_desc,
                    medicine_name: row.medicine_name,
                    medicine_dose: row.medicine_dose,
                    animal_count: row.animal_count,
                    action: (
                        <Button
                            color="info"
                            size="sm"
                            outline
                            className="d-flex align-items-center gap-1"
                            onClick={() => viewDetailsHandler(row)}
                        >
                            <FaEye size={14} />
                            View
                        </Button>
                    ),
                    rawData: row
                };
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} livestock activities loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Failed to load livestock activities. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const viewDetailsHandler = (data) => {
        setModalData(data);
        setViewModal(true);
    };

    const download_excel_handler = async () => {
        setDownloadLoading(true);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Activity/liv_activity_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl_no: index + 1,
                    farmer_id: row.farmer_id,
                    farmer_name: row.f_name,
                    activity_date: row.activity_date?.split(" ")[0].split('-').reverse().join('-'),
                    activity_description: row.activity_desc,
                    medicine_name: row.medicine_name,
                    medicine_dose: row.medicine_dose,
                    animal_count: row.animal_count,
                };
            });

            if (list.length > 0) {
                let wb = XLSX.utils.book_new(),
                    ws = XLSX.utils.json_to_sheet(list);
                XLSX.utils.book_append_sheet(wb, ws, "Livestock_Activity_Report");
                XLSX.writeFile(wb, `livestock_activity_report_${new Date().toISOString().split('T')[0]}.xlsx`);

                let notify = notification({
                    message: "Excel report downloaded successfully!",
                    type: 'success'
                });
                notify();
            } else {
                let notify = notification({
                    message: "No data available for download",
                    type: 'warning'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.farmer_id.toLowerCase().includes(value.toLowerCase()) ||
                item.f_name.toLowerCase().includes(value.toLowerCase()) ||
                item.activity_desc.toLowerCase().includes(value.toLowerCase()) ||
                item.medicine_name.toLowerCase().includes(value.toLowerCase()) ||
                item.activity_date.includes(value)
            );
            setFilteredData(filtered);
        }
    };

    // Calculate statistics
    const totalActivities = tableData.length;
    const totalAnimals = tableData.reduce((sum, item) => sum + parseInt(item.animal_count || 0), 0);
    const uniqueFarmers = new Set(tableData.map(item => item.farmer_id)).size;
    const uniqueMedicines = new Set(tableData.map(item => item.medicine_name)).size;

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUser size={12} />
                    Farmer ID
                </div>
            ),
            selector: row => row.farmer_id,
            sortable: true,
            width: '120px',
            cell: row => (
                <Badge color="light" className="text-primary" pill>
                    {row.farmer_id}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUsers size={12} />
                    Farmer Name
                </div>
            ),
            selector: row => row.f_name,
            sortable: true,
            width: '180px',
            cell: row => (
                <div className="text-truncate" title={row.f_name}>
                    {row.f_name || 'N/A'}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Activity Date
                </div>
            ),
            selector: row => row.activity_date,
            sortable: true,
            width: '140px',
            cell: row => (
                <Badge color="secondary" outline>
                    {row.activity_date || 'N/A'}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaStethoscope size={12} />
                    Activity
                </div>
            ),
            selector: row => row.activity_desc,
            sortable: true,
            width: '200px',
            cell: row => (
                <div className="text-truncate" title={row.activity_desc}>
                    <Badge 
                        color={
                            row.activity_desc?.toLowerCase().includes('vaccination') ? 'success' :
                            row.activity_desc?.toLowerCase().includes('treatment') ? 'warning' :
                            row.activity_desc?.toLowerCase().includes('checkup') ? 'info' :
                            'secondary'
                        }
                        className="text-white"
                    >
                        {row.activity_desc || 'N/A'}
                    </Badge>
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaPills size={12} />
                    Medicine
                </div>
            ),
            selector: row => row.medicine_name,
            sortable: true,
            width: '150px',
            cell: row => (
                <div className="text-truncate" title={row.medicine_name}>
                    {row.medicine_name || 'N/A'}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaPills size={12} />
                    Dose
                </div>
            ),
            selector: row => row.medicine_dose,
            sortable: true,
            width: '100px',
            cell: row => (
                <Badge color="light" className="text-dark">
                    {row.medicine_dose || 'N/A'}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaPaw size={12} />
                    Animals
                </div>
            ),
            selector: row => row.animal_count,
            sortable: true,
            center: true,
            width: '100px',
            cell: row => (
                <Badge 
                    color={
                        parseInt(row.animal_count) > 20 ? 'success' : 
                        parseInt(row.animal_count) > 10 ? 'warning' : 
                        'danger'
                    } 
                    pill
                >
                    {row.animal_count}
                </Badge>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Livestock Activity Management' breadcrumbs='Home / Livestock Activity'>
                <Row className='p-3'>
                    {mode === "1" && (
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={get_livestock_Activity}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaStethoscope size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Activity Data'}
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    onClick={download_excel_handler}
                                                    disabled={downloadLoading || tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    {downloadLoading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaDownload size={14} />
                                                    )}
                                                    {downloadLoading ? 'Downloading...' : 'Download Excel'}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search activities, farmers, medicines...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaStethoscope size={24} className="mb-2" />
                                                <h5 className="mb-0">{totalActivities}</h5>
                                                <small>Total Activities</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaPaw size={24} className="mb-2" />
                                                <h5 className="mb-0">{totalAnimals}</h5>
                                                <small>Animals Treated</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUsers size={24} className="mb-2" />
                                                <h5 className="mb-0">{uniqueFarmers}</h5>
                                                <small>Active Farmers</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaPills size={24} className="mb-2" />
                                                <h5 className="mb-0">{uniqueMedicines}</h5>
                                                <small>Different Medicines</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Livestock Activity Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} activities` :
                                                    'No activity records found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaStethoscope size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No livestock activity data loaded yet</p>
                                            <small>Click "Load Activity Data" to fetch the latest records</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading activity data...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No activities match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Page>

            {/* Enhanced Modal for Activity Details */}
            <Modal
                centered
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaStethoscope className="text-primary" />
                        <div>
                            <h5 className="mb-0">Livestock Activity Details</h5>
                            <small className="text-muted">
                                Complete activity information
                            </small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {modalData && (
                        <div className="row g-3">
                            <div className="col-12">
                                <Card className="border-0 bg-light">
                                    <CardBody>
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Farmer Information</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="mb-2">
                                                        <small className="text-muted">Farmer ID</small>
                                                        <div className="fw-bold">
                                                            <Badge color="primary" pill>{modalData.farmer_id}</Badge>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">Farmer Name</small>
                                                        <div className="fw-bold">{modalData.f_name || 'N/A'}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Activity Information</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="mb-2">
                                                        <small className="text-muted">Activity Date</small>
                                                        <div className="fw-bold">
                                                            <Badge color="secondary" outline>
                                                                <FaCalendarAlt size={12} className="me-1" />
                                                                {modalData.activity_date || 'N/A'}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">Activity Description</small>
                                                        <div className="fw-bold">
                                                            <Badge 
                                                                color={
                                                                    modalData.activity_desc?.toLowerCase().includes('vaccination') ? 'success' :
                                                                    modalData.activity_desc?.toLowerCase().includes('treatment') ? 'warning' :
                                                                    modalData.activity_desc?.toLowerCase().includes('checkup') ? 'info' :
                                                                    'secondary'
                                                                }
                                                                className="text-white"
                                                            >
                                                                <FaStethoscope size={12} className="me-1" />
                                                                {modalData.activity_desc}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Medicine Details</label>
                                                <div className="p-3 bg-white rounded border">
                                                    <div className="mb-2">
                                                        <small className="text-muted">Medicine Name</small>
                                                        <div className="fw-bold">
                                                            <FaPills size={14} className="text-primary me-1" />
                                                            {modalData.medicine_name || 'N/A'}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">Medicine Dose</small>
                                                        <div className="fw-bold">
                                                            <Badge color="light" className="text-dark border">
                                                                {modalData.medicine_dose || 'N/A'}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <label className="form-label text-muted small fw-bold">Animal Count</label>
                                                <div className="p-3 bg-white rounded border text-center">
                                                    <div className="display-6 mb-2">
                                                        <FaPaw className="text-primary" />
                                                    </div>
                                                    <div>
                                                        <Badge 
                                                            color={
                                                                parseInt(modalData.animal_count) > 20 ? 'success' : 
                                                                parseInt(modalData.animal_count) > 10 ? 'warning' : 
                                                                'danger'
                                                            } 
                                                            pill
                                                            className="fs-5"
                                                        >
                                                            {modalData.animal_count} Animals
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            <Footer />
        </>
    );
};

export default LivestockActivity;